<template>
    <div>
        <a class="menu-toggle" :class="{open: isOpen}" @click="toggleMenu" href="#"><div class="navicon"></div></a>
    </div>
</template>

<script>
    export default {
        name: 'MenuToggle',
        methods: {
            toggleMenu(e) {
                e.preventDefault();
                this.$store.dispatch('toggleMenu');
            }
        },
        computed: {
            isOpen() {
                return this.$store.state.menu.open;
            }
        }
        
    };
</script>

<style scoped>
    
    .menu-toggle {position: relative; /*top: 50%; transform: translateY(-50%);*/ display: block; cursor: pointer; height: 2em; width: 2em; font-size: .75rem;}
    .menu-toggle.open {}
        .menu-toggle > .navicon, .menu-toggle > .navicon:before, .menu-toggle > .navicon:after {background-color: rgba(250,250,250,1); height: .25em; width: 100%; display: block; position: absolute; top: 0; bottom: 0; margin: auto; transition: .25s;}
        .menu-toggle > .navicon {}
        .menu-toggle > .navicon:before {content: ''; top: 0; transform: translateY(-.6em) rotate(0deg);}
        .menu-toggle > .navicon:after {content: ''; bottom: 0; transform: translateY(.6em) rotate(0deg);}
        .menu-toggle.open > .navicon {background-color: rgba(250,250,250,0);}
        .menu-toggle.open > .navicon:before {top: 0; transform: translateY(0em) rotate(45deg);}
        .menu-toggle.open > .navicon:after {bottom: 0; transform: translateY(0em)  rotate(-45deg);}
    
</style>